import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from "@mui/material";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import PayrollViewController from "../../redux/actions/payrollApiAction";

const AddSalaryReportMonth = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const { genrateSalaryReport } = PayrollViewController();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [openCalendar, setOpenCalendar] = useState(false);
  const [activeField, setActiveField] = useState(null); // "start" or "end"

  const handleDateSelect = (date) => {
    if (activeField === "start") {
      setStartDate(date);
    } else if (activeField === "end") {
      setEndDate(date);
    }
    setOpenCalendar(false);
  };

  const handleGenerate = () => {
    if (!startDate || !endDate) return;

    const payload = {
      start_date: dayjs(startDate).format("YYYY-MM-DD"),
      end_date: dayjs(endDate).format("YYYY-MM-DD"),
    };
    dispatch(genrateSalaryReport(payload));
    handleClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Generate Salary Report</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3} mt={1}>
            <Grid item xs={6}>
              <TextField
                label="Start Date"
                value={startDate ? dayjs(startDate).format("YYYY-MM-DD") : ""}
                onClick={() => {
                  setActiveField("start");
                  setOpenCalendar(true);
                }}
                fullWidth
                size="small"
                placeholder="Select Start Date"
                readOnly
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="End Date"
                value={endDate ? dayjs(endDate).format("YYYY-MM-DD") : ""}
                onClick={() => {
                  setActiveField("end");
                  setOpenCalendar(true);
                }}
                fullWidth
                size="small"
                placeholder="Select End Date"
                readOnly
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleGenerate}
            variant="contained"
            color="primary"
            disabled={!startDate || !endDate}
          >
            Generate
          </Button>
        </DialogActions>
      </Dialog>

      {/* Calendar Modal */}
      <Dialog open={openCalendar} onClose={() => setOpenCalendar(false)}>
        <DialogTitle>Select a Date</DialogTitle>
        <DialogContent>
          <DateCalendar
            onChange={(date) => handleDateSelect(date)}
            value={activeField === "start" ? startDate : endDate}
          />
        </DialogContent>
      </Dialog>
    </LocalizationProvider>
  );
};

export default AddSalaryReportMonth;
